module.exports = __webpack_public_path__ + "img/face_gather5.da84ca33.png";